module.exports = __webpack_public_path__ + "static/img/h7-1.3f5603d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h7-1.png
// module id = VJXP
// module chunks = 1